"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentTypeOptions = exports.bankCodeOptions = exports.bankAccountTypeOptions = void 0;
exports.bankAccountTypeOptions = [
    { label: 'SAVINGS', value: 'SAVINGS' },
    { label: 'CHECKING', value: 'CHECKING' },
    { label: 'VISTA', value: 'VISTA' },
    { label: 'RUT', value: 'RUT' },
    { label: 'SALARY', value: 'SALARY' },
    { label: 'EMAIL', value: 'EMAIL' },
];
exports.bankCodeOptions = [
    { label: 'Bank of Chile - Edwards', value: '001' },
    { label: 'Banco Internacional', value: '009' },
    { label: 'Banco Estado (Banco del Estado de Chile)', value: '012' },
    { label: 'Scotiabank', value: '014' },
    { label: 'BCI (Bco de Credito e Inv)', value: '016' },
    { label: 'Banco do Brasil', value: '017' },
    { label: 'Itau-Corpbanca', value: '027' },
    { label: 'Banco Bice', value: '028' },
    { label: 'HSBC Bank', value: '031' },
    { label: 'Banco Santiago', value: '035' },
    { label: 'Banco Santander', value: '037' },
    { label: 'Itau Chile', value: '039' },
    { label: 'JP Morgan Chase Bank N.A.', value: '041' },
    { label: 'Banco de La Nacion Argentina', value: '043' },
    { label: 'The Bank of Tokyo-Mitsubishi Ufj, Ltd', value: '045' },
    { label: 'Banco Security', value: '049' },
    { label: 'Banco Falabella', value: '051' },
    { label: 'Deutsche Bank (Chile)', value: '052' },
    { label: 'Banco Ripley', value: '053' },
    { label: 'Rabobank', value: '054' },
    { label: 'Banco Consorcio', value: '055' },
    { label: 'Banco Penta', value: '056' },
    { label: 'Banco Paris', value: '057' },
    { label: 'Banco Ptg Pactual', value: '059' },
    { label: 'Banco Nuevo', value: '099' },
    { label: 'Prepago Los Heroes', value: '152' },
    { label: 'BBVA (Bco Bilbao Vizcaya Arg)', value: '504' },
    { label: 'Banco del Desarrollo', value: '507' },
    { label: 'Coopeuch', value: '672' },
];
exports.documentTypeOptions = [
    { label: 'RUT', value: 'RUT' },
    { label: 'RUN', value: 'RUN' },
];
